import { render, staticRenderFns } from "./CheckoutNotesRow.vue?vue&type=template&id=797da2ef&"
import script from "./CheckoutNotesRow.vue?vue&type=script&lang=js&"
export * from "./CheckoutNotesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports